
import { Organization } from "@/types/subscription";

type RemainingInvitesInfoProps = {
  remainingInvites: number;
  selectedOrg: Organization | null;
};

const RemainingInvitesInfo = ({ remainingInvites, selectedOrg }: RemainingInvitesInfoProps) => {
  // Nous considérons toujours un nombre élevé d'invitations disponibles
  const unlimitedInvites = 999;
  
  return (
    <div className="mb-6">
      <p className="text-sm">
        Il vous reste <span className="text-blue-500 font-medium">{unlimitedInvites} invitations</span> disponibles.
      </p>
    </div>
  );
};

export default RemainingInvitesInfo;
